/**
 * [data-reveal] işaretli elemanları görünür alana girdiklerinde açar.
 * IntersectionObserver desteklenmiyorsa (eski tarayıcı) hepsi anında açılır.
 * Dönen fonksiyon observer'ı kapatır — beforeDestroy içinde çağırılmalı.
 */
export function initReveal(root: Element | Document = document): () => void {
  const nodes = Array.prototype.slice.call(
    root.querySelectorAll("[data-reveal]")
  ) as HTMLElement[];

  if (typeof IntersectionObserver === "undefined") {
    nodes.forEach((n) => n.classList.add("is-in"));
    return () => undefined;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target as HTMLElement;
        // Aynı grup içindeki elemanlara kademeli gecikme uygula.
        const delay = Number(el.getAttribute("data-reveal")) || 0;
        el.style.transitionDelay = delay + "ms";
        el.classList.add("is-in");
        observer.unobserve(el);
      });
    },
    // Yüzdesel rootMargin çok uzun görüntü alanlarında sayfanın altındaki
    // elemanları hiç tetiklemiyor; sabit piksel değeri güvenli.
    { rootMargin: "0px 0px -80px 0px", threshold: 0.05 }
  );

  nodes.forEach((n) => observer.observe(n));

  return () => observer.disconnect();
}
